import { Navigate } from 'react-router';

export const redirectToLogin = () => {
  window.location.replace('/login');
};

export const RedirectToLoginPage = () => {
  return <Navigate to="/login" replace />;
};
